export default __webpack_public_path__ + "static/media/guide0204_m.a06ef2ed.jpg";